export default __webpack_public_path__ + "static/screen-web-a4a8e2b028e86b0790cc95bd4fde6605.png";